import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon, Modal } from 'antd';
import TextEvents from 'app/components/TextEvents';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../../UserSearchScreenStyles';
import * as UserSearchActions from 'app/actions/UserSearchActions';
import { debounce } from 'debounce';

import TextInput from 'app/components/TextInput';
import { employeeById } from 'app/reducers';
import TechnicalRepresentativeContainer from 'app/containers/TechnicalRepresentativeContainer';


const ExternalEmployeesFilterComponent = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    //Datos gurdados en el estado del modulo para uso de filtros
    const [employeesNames, setEmployeesNames] = useState([]);
    const [employeesEmail, setEmployeesEmail] = useState([]);
    const [collapse, setCollapse] = useState(false);


    //Datos del store de redux
    const {
        listExternalEmployeesNames,
        isLoadingExternalEmployeesNames,

        isLoadingExternalEmail,
        listExternalEmployeesEmail,

        filterExternal,
        paginationExternal,

        isExportingExternalXls,
        isExportingBookmarkXls
    } = useSelector(state => state.UserSearchReducer);

    //Filtro: Nombre Empleado
    const optionExternalEmployeesNames = listExternalEmployeesNames.map((item) =>
        (<Select.Option key={item.value} value={item.value} /*key={item.key} value={item.key}*/>{item.value}</Select.Option>)
    );
    //Filtro: Correos de empleados
    const optionExternalEmployeesEmail = listExternalEmployeesEmail.map((item) =>
        (<Select.Option key={item.value} value={item.value} /*key={item.key} value={item.key}*/>{item.value}</Select.Option>)
    );

    const employeeData = useSelector(employeeById)
    const [openModal, setOpenModal] = useState(false);
    const [revisor, setRevisor] = useState("");
    const { Option } = Select;


    //Cambio en seleccion de filtro nombres
    const onEmployeesNamesChange = (names) => {
        setEmployeesNames(names);
        const obj = {
            listExternalEmployeesNames: names,
            listExternalEmployeesEmail: employeesEmail
        }

        dispatch(UserSearchActions.saveFilterExternal(obj));
    }

    //Cambio en seleccion de filtro correo electronico
    const onEmployeesEmailChange = (email) => {
        setEmployeesEmail(email);
        const obj = {
            listExternalEmployeesNames: employeesNames,
            listExternalEmployeesEmail: email
        }

        dispatch(UserSearchActions.saveFilterExternal(obj));
    }

    //Accion clic botón buscar
    const search = () => {
        dispatch(UserSearchActions.fetchExternalEmployees({
            offset: 0,
            limit: paginationExternal.pageSize,
            sortColumn: paginationExternal.column,
            sortDir: paginationExternal.order,
            listNames: filterExternal.listExternalEmployeesNames.length > 0 ? filterExternal.listExternalEmployeesNames.join("|") : '',
            listEmails: filterExternal.listExternalEmployeesEmail.length > 0 ? filterExternal.listExternalEmployeesEmail.join("|") : ''
        }));
    }

    //Accion clic de botón exportar
    const exportXls = () => {
        dispatch(UserSearchActions.exportExternalXls({
            offset: 0,
            limit: paginationExternal.pageSize,
            sortColumn: paginationExternal.column,
            sortDir: paginationExternal.order,
            listNames: filterExternal.listExternalEmployeesNames.length > 0 ? filterExternal.listExternalEmployeesNames.join("|") : '',
            listEmails: filterExternal.listExternalEmployeesEmail.length > 0 ? filterExternal.listExternalEmployeesEmail.join("|") : ''
        }));
    }

    const exportGenerate = () => {
        dispatch(UserSearchActions.exportBookmark({
            IsExternal: true,
            listNames: filterExternal.listExternalEmployeesNames.length > 0 ? filterExternal.listExternalEmployeesNames.join("|") : '',
            listEmails: filterExternal.listExternalEmployeesEmail.length > 0 ? filterExternal.listExternalEmployeesEmail.join("|") : '',
            elaborador: `${employeeData.firstName} ${employeeData.lastName}`,
            revisor: revisor
        }, "Externos"));

        setOpenModal(false);
        setRevisor("");
    }

    //Funcion para filtrar nombres
    const handleSearchName = name => {
        if (name !== '') {
            dispatch(UserSearchActions.getExternalEmployeesNames(name));
        }
    }

    //Funcion para filtrar emails
    const handleSearchEmail = email => {
        if (email !== '') {
            dispatch(UserSearchActions.getExternalEmployeesEmail(email));
        }
    }

    const findTechnical = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.technical[values[i]].idResponsible;
            params.technical.forEach((v) => {
                if (v.idResponsible === id) {
                    temp.push(v);
                }
            });
        }
        setRevisor(temp[0].responsibleName);
    }

    const SelectItem = (name = [], value) => {
        if (name == null) name = [];
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    return (
        <div>
             <Modal
                  title="Nombre del Revisor del documento (Representante técnico)"
                visible={openModal}
                onOk={() => exportGenerate()}
                onCancel={
                    () => {
                        setOpenModal(false);
                        setRevisor("");
                    }}
                okText="Generar"
                cancelText="Cancelar"
                okButtonProps={{ disabled: revisor == "" }}
            >
                <TechnicalRepresentativeContainer>
                    {(params) => {
                        return (

                            <TextInput
                                text=''
                                color='darker'
                                size='label'
                                weight='medium'
                                placeholder='Selecciona revisor'
                                style={styles.inputSelect}
                                showSearch
                                onChange={(v) => {
                                    findTechnical(params, v);
                                }}
                            >
                                {SelectItem(params.technical, 'responsibleName')}
                            </TextInput>
                        )
                    }}
                </TechnicalRepresentativeContainer>
            </Modal>
            <div hidden={collapse}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={6} >
                        <TextEvents
                            text='Nombre:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingExternalEmployeesNames}
                            placeholder="[Selecione nombre]"
                            showSearch
                            onChange={onEmployeesNamesChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            // filterOption={(input, option) =>
                            //     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            // }
                            allowClear
                            showArrow={false}
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={debounce(handleSearchName, 500)}
                            mode="multiple"
                        >
                            {optionExternalEmployeesNames}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Correo electrónico:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingExternalEmail}
                            placeholder="[Selecione correo electrónico]"
                            showSearch
                            onChange={onEmployeesEmailChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            // filterOption={(input, option) =>
                            //     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            // }
                            allowClear
                            showArrow={false}
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={debounce(handleSearchEmail, 500)}
                            mode="multiple"
                        >
                            {optionExternalEmployeesEmail}
                        </Select>
                    </Grid>
                </Grid>
            </div>
            {/*Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                    collapse ?
                        <Tooltip title={"Mostrar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(false)}
                            >
                                <Icon type="down" />
                            </Button>
                        </Tooltip> :
                        <Tooltip title={"Ocultar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(true)}
                            >
                                <Icon type="up" />
                            </Button>
                        </Tooltip>
                }
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    loading={isExportingExternalXls}
                    variant="contained"
                    type="primary"
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button>
                <Button
                    className={classes.button}
                    variant="contained"
                    disabled={employeesNames.length == 0}
                    loading={isExportingBookmarkXls}
                    type="primary"
                    onClick={() => setOpenModal(true)}
                >
                    Generar
                </Button>
            </div>
        </div>
    );
}

export default ExternalEmployeesFilterComponent;
